
/* ===================================================================== the map */
(function(){
"use strict";
var MAPST={map:null,ready:false,place:null,selKey:null,layers:{},
           show:{places:1,regions:1,routes:1,parallels:0,borders:0},
           unplaced:[],markers:{},pending:null};
window.MAPST=MAPST;

function P(){ return (typeof DB!=="undefined"&&DB&&DB.placements)||null; }
function RL(){ return (typeof DB!=="undefined"&&DB&&DB.regionLabels)||{}; }
function NA(id){return "data-"+"node="+JSON.stringify(String(id));}
function esc2(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){
  return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c];});}

/* anchor key for a node: a place name, a region name, or null */
function anchorOf(id){
  var p=P(); if(!p) return null; var r=p[id]; if(!r) return null;
  if(r.tier==="P1"||r.tier==="P2") return {key:"place:"+r.place,lat:r.lat,lon:r.lon,tier:r.tier,
    name:r.place,kind:r.place_kind,note:r.reason};
  if(r.tier==="P3") return {key:"region:"+r.region,lat:r.lat,lon:r.lon,tier:"P3",
    name:RL()[r.region]||r.region,kind:"region",note:r.reason};
  return null;
}

/* a gently curved line, so two routes between the same pair stay distinguishable */
function arc(a,b,bend){
  var pts=[],n=26,
      mLat=(a[0]+b[0])/2, mLon=(a[1]+b[1])/2,
      dLat=b[0]-a[0], dLon=b[1]-a[1];
  var cx=mLat - dLon*bend, cy=mLon + dLat*bend;
  for(var i=0;i<=n;i++){var t=i/n,u=1-t;
    pts.push([u*u*a[0]+2*u*t*cx+t*t*b[0], u*u*a[1]+2*u*t*cy+t*t*b[1]]);}
  return pts;
}

function inWindow(n){ return !(n._e < S.t0 || n._s > S.t1); }

function collect(){
  var byAnchor={}, unplaced=[], p=P();
  NODES.forEach(function(n){
    if(!inWindow(n)) return;
    if(!visibleBase(n)) return;
    if(S.q && !n._hay.includes(S.q)) return;
    var a=anchorOf(n.id);
    if(!a){ unplaced.push(n); return; }
    (byAnchor[a.key]=byAnchor[a.key]||{a:a,ns:[]}).ns.push(n);
  });
  return {byAnchor:byAnchor,unplaced:unplaced};
}

/* the atlas's own visibility test, minus the map's place filter (avoids recursion) */
function visibleBase(n){
  if(!S.confs.has(n.date_confidence))return false;
  if(S.scope==="core" && (n.nondual_types||[]).length &&
     (n.nondual_types||[]).every(function(t){return t==="not-applicable";}))return false;
  return true;
}

function popupFor(a,ns){
  var head='<div class="gm-pop"><h4>'+esc2(a.name)+'</h4>';
  if(a.tier==="P2") head+='<div class="gm-prec">approximate location</div>';
  if(a.tier==="P3") head+='<div class="gm-prec">region only — not a point</div>';
  if(a.note) head+='<div class="gm-note">'+esc2(a.note)+'</div>';
  var list=ns.slice().sort(function(x,y){return x._s-y._s;});
  var body='<ul>'+list.slice(0,24).map(function(n){
    return '<li><button '+NA(n.id)+'>'+esc2(n.date_display)+' — '+esc2(n.label)+'</button></li>';
  }).join('')+'</ul>';
  if(list.length>24) body+='<div class="gm-more">…and '+(list.length-24)+' more. Filter the timeline to this place to see them all.</div>';
  body+='<div class="gm-more"><button data-mapfilter="'+esc2(a.key)+'" style="font:inherit;background:none;border:0;padding:0;color:var(--ink-s);border-bottom:1px solid var(--rule-2);cursor:pointer">Filter the timeline to this place →</button></div>';
  return head+body+'</div>';
}

function draw(){
  if(!MAPST.ready) return;
  var L_=window.L, lay=MAPST.layers;
  ["places","regions","routes","parallels"].forEach(function(k){ lay[k].clearLayers(); });
  MAPST.markers={};
  var c=collect(), byAnchor=c.byAnchor;
  MAPST.unplaced=c.unplaced;

  Object.keys(byAnchor).forEach(function(key){
    var a=byAnchor[key].a, ns=byAnchor[key].ns;
    if(a.lat==null) return;
    var target = a.tier==="P3" ? lay.regions : lay.places;
    var g;
    if(a.tier==="P3"){
      g=L_.circleMarker([a.lat,a.lon],{radius:Math.min(30,11+Math.sqrt(ns.length)*2.6),
        className:"gm-region",interactive:true});
    }else if(a.tier==="P2"){
      lay.places.addLayer(L_.circleMarker([a.lat,a.lon],
        {radius:Math.min(22,9+Math.sqrt(ns.length)*2.4),className:"gm-p2-halo",interactive:false}));
      g=L_.circleMarker([a.lat,a.lon],{radius:Math.min(11,4+Math.sqrt(ns.length)*1.7),className:"gm-p2"});
    }else{
      g=L_.circleMarker([a.lat,a.lon],{radius:Math.min(13,3.6+Math.sqrt(ns.length)*1.7),className:"gm-p1"});
    }
    g.bindPopup(popupFor(a,ns),{maxWidth:340,autoPan:true});
    g.bindTooltip(a.name+" · "+ns.length+(ns.length===1?" entry":" entries"),{direction:"top",opacity:.95});
    g._gmKey=key;
    MAPST.markers[key]=g;
    target.addLayer(g);
    if(key===MAPST.selKey && g._path) g._path.classList.add("gm-sel");
    if(MAPST.place && key===MAPST.place && g._path) g._path.classList.add("gm-sel");
  });

  /* routes — quiet by default, loud for the selected entry */
  var seen={}, sel=S.sel;
  if(S.edgeMode!=="none") CONNS.forEach(function(cn){
    if(!S.types.has(cn.type)) return;
    var touches = !!sel && (cn.from===sel || cn.to===sel);
    var A=BYID[cn.from], B=BYID[cn.to];
    if(!A||!B) return;
    if(!inWindow(A)&&!inWindow(B)) return;
    if(!visibleBase(A)||!visibleBase(B)) return;
    var pa=anchorOf(cn.from), pb=anchorOf(cn.to);
    if(!pa||!pb||pa.key===pb.key||pa.lat==null||pb.lat==null) return;
    var soft = (pa.tier==="P3"||pb.tier==="P3");
    var k=pa.key+"|"+pb.key+"|"+cn.type;
    seen[k]=(seen[k]||0)+1;
    var bend=0.055+0.045*((seen[k]-1)%3);
    var pts=arc([pa.lat,pa.lon],[pb.lat,pb.lon],bend);
    var cls="gm-r gm-r"+cn.type+(soft?" gm-soft":"")+(touches?" gm-loud":" gm-quiet");
    var pl=window.L.polyline(pts,{className:cls,interactive:true,weight:2});
    var label=({A:"A · documented",B:"B · strongly supported",C:"C · plausible",
                D:"D · philosophical parallel — not a transmission",E:"E · contested",
                F:"F · traditional lineage claim, not documented"})[cn.type];
    pl.bindTooltip(esc2(A.label)+" → "+esc2(B.label)+"<br><b>"+label+"</b>"+
      (soft?"<br><i>drawn between region centres — approximate</i>":""),{sticky:true,opacity:.96});
    (cn.type==="D"?MAPST.layers.parallels:MAPST.layers.routes).addLayer(pl);
  });

  /* the honest counter */
  var u=document.getElementById("unplacedN");
  if(u) u.textContent=MAPST.unplaced.length.toLocaleString();
  var box=document.getElementById("unplacedList");
  if(box && !box.hidden) fillUnplaced();
  applyShow();
}

function fillUnplaced(){
  var box=document.getElementById("unplacedList"); if(!box) return;
  var p=P();
  var rows=MAPST.unplaced.slice().sort(function(a,b){return a._s-b._s;});
  box.innerHTML = rows.length ? rows.slice(0,400).map(function(n){
    var why=(p&&p[n.id]&&p[n.id].reason)||"no defensible location";
    return '<div><button '+NA(n.id)+'>'+esc2(n.date_display)+' — '+esc2(n.label)+
           '</button> <span style="color:var(--ink-m);font-size:11.5px">· '+esc2(why)+'</span></div>';
  }).join('')+(rows.length>400?'<div style="color:var(--ink-m)">…and '+(rows.length-400)+' more.</div>':'')
   : '<div style="color:var(--ink-m)">None in this era.</div>';
}

function applyShow(){
  var m=MAPST.map, lay=MAPST.layers;
  if(!m) return;
  ["places","regions","routes","parallels","borders"].forEach(function(k){
    if(MAPST.show[k]){ if(!m.hasLayer(lay[k])) m.addLayer(lay[k]); }
    else { if(m.hasLayer(lay[k])) m.removeLayer(lay[k]); }
  });
}

function init(){
  var L_=window.L; if(!L_||!document.getElementById("geomap")) return;
  var m=L_.map("geomap",{crs:L_.CRS.EPSG4326,minZoom:-2,maxZoom:8,zoomSnap:0,zoomDelta:.6,zoomControl:true,
    worldCopyJump:false,attributionControl:true,scrollWheelZoom:false,
    maxBounds:[[-89,-185],[89,185]],maxBoundsViscosity:.8});
  m.attributionControl.setPrefix("");
  m.attributionControl.addAttribution(
    'Basemap: <a href="https://www.naturalearthdata.com/" target="_blank" rel="noopener">Natural Earth</a> (public domain) · ' +
    '<a href="https://leafletjs.com/" target="_blank" rel="noopener">Leaflet</a> · no tiles are fetched');
  m.setView([26,58],0);
  MAPST.map=m;
  var geo=(typeof DB!=="undefined"&&DB&&DB.geo)||{};
  if(geo.land) L_.geoJSON(geo.land,{style:{className:"gm-land"},interactive:false}).addTo(m);
  MAPST.layers.borders = geo.borders
      ? L_.geoJSON(geo.borders,{style:{className:"gm-border"},interactive:false})
      : L_.layerGroup();
  ["places","regions","routes","parallels"].forEach(function(k){ MAPST.layers[k]=L_.layerGroup(); });
  ["regions","routes","parallels","places"].forEach(function(k){ m.addLayer(MAPST.layers[k]); });
  MAPST.ready=true;

  m.on("click",function(){ if(MAPST.place) setPlace(null); });

  document.querySelectorAll(".map-toggle[data-layer]").forEach(function(b){
    b.addEventListener("click",function(){
      var k=b.dataset.layer, on=b.getAttribute("aria-pressed")!=="true";
      b.setAttribute("aria-pressed",on?"true":"false");
      MAPST.show[k]=on?1:0; applyShow();
    });
  });
  var fit=document.getElementById("mapFit");
  if(fit) fit.addEventListener("click",function(){
    var b=[];
    Object.keys(MAPST.markers).forEach(function(k){ var g=MAPST.markers[k]; b.push(g.getLatLng()); });
    if(b.length) m.fitBounds(L_.latLngBounds(b).pad(.12));
  });
  var clr=document.getElementById("mapClear");
  if(clr) clr.addEventListener("click",function(){ setPlace(null); });
  var ut=document.getElementById("unplacedToggle");
  if(ut) ut.addEventListener("click",function(){
    var box=document.getElementById("unplacedList");
    var open=box.hidden; box.hidden=!open;
    ut.setAttribute("aria-expanded",open?"true":"false");
    ut.textContent=open?"Hide them ↑":"Show them ↓";
    if(open) fillUnplaced();
  });
  draw();
  function fitAll(){
    m.invalidateSize(false);
    var b=[];Object.keys(MAPST.markers).forEach(function(k){b.push(MAPST.markers[k].getLatLng());});
    if(b.length>2) m.fitBounds(L_.latLngBounds(b),{padding:[14,14],animate:false});
  }
  fitAll(); setTimeout(fitAll,240); setTimeout(fitAll,900);
  var rz=null;
  window.addEventListener("resize",function(){ if(rz)clearTimeout(rz);
    rz=setTimeout(function(){ m.invalidateSize(false); },220); });
  if(MAPST.pending){ var id=MAPST.pending; MAPST.pending=null; focus(id); }
}

function setPlace(key){
  MAPST.place=key;
  var clr=document.getElementById("mapClear");
  if(clr) clr.hidden=!key;
  Object.keys(MAPST.markers).forEach(function(k){
    var g=MAPST.markers[k]; if(!g._path) return;
    g._path.classList.toggle("gm-sel", (!!key && k===key) || k===MAPST.selKey);
  });
  if(typeof render==="function") render();
}

function focus(id){
  if(!MAPST.ready){ MAPST.pending=id; return; }
  var a=anchorOf(id);
  var badgeHost=document.getElementById("panelBody");
  if(!a){
    MAPST.selKey=null;
    if(badgeHost && !badgeHost.querySelector(".gm-badge")){
      var p=P(), why=(p&&p[id]&&p[id].reason)||"no defensible location";
      var d=document.createElement("div");
      d.className="gm-badge";
      d.textContent="geographically uncertain — "+why;
      var h=badgeHost.querySelector(".m"); if(h&&h.parentNode) h.parentNode.insertBefore(d,h.nextSibling);
      else badgeHost.insertBefore(d,badgeHost.firstChild);
    }
    return;
  }
  MAPST.selKey=a.key;
  MAPST.map.setView([a.lat,a.lon], Math.max(MAPST.map.getZoom(),3), {animate:true});
  Object.keys(MAPST.markers).forEach(function(k){
    var mk=MAPST.markers[k]; if(mk._path) mk._path.classList.toggle("gm-sel",k===a.key);
  });
  var g=MAPST.markers[a.key];
  if(g) g.openPopup();
}

/* ---- hook into the atlas ------------------------------------------------- */
window.GEOMAP={init:init,draw:draw,focus:focus,setPlace:setPlace,
  filterNode:function(n){
    if(!MAPST.place) return true;
    var a=anchorOf(n.id);
    return !!a && a.key===MAPST.place;
  }};

document.addEventListener("click",function(e){
  var f=e.target.closest("[data-mapfilter]");
  if(f){ e.preventDefault(); setPlace(f.dataset.mapfilter);
         if(MAPST.map) MAPST.map.closePopup(); }
});
})();

/* wrap the atlas's own entry points — declarations, so rebinding is safe */
(function(){
  var _visible=visible, _render=render, _openPanel=openPanel, _boot=boot;
  visible=function(n){ return _visible(n) && window.GEOMAP.filterNode(n); };
  var raf=null;
  render=function(){ _render.apply(this,arguments);
    if(raf) cancelAnimationFrame(raf);
    raf=requestAnimationFrame(function(){ raf=null; window.GEOMAP.draw(); }); };
  openPanel=function(id){ _openPanel.apply(this,arguments); window.GEOMAP.focus(id); };
})();

/* the map boots once the atlas data has landed */
(function(){
  var t=setInterval(function(){
    if(typeof DB!=="undefined" && DB && typeof NODES!=="undefined" && NODES.length && window.L){
      clearInterval(t); window.GEOMAP.init();
    }
  },90);
  setTimeout(function(){clearInterval(t);},30000);
})();
